import { Result, Button } from "antd"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { ErrorLayout } from "./ErrorLayout"

export const Error403: React.FC = () => {
  const { t } = useTranslation()
  return (
    <ErrorLayout>
      <Result
        status="403"
        title={t("pages.403.title")}
        subTitle={t("pages.403.subTitle")}
        extra={
          <Button size="large" type="primary">
            <Link to="/">{t("pages.403.link")}</Link>
          </Button>
        }
      />
    </ErrorLayout>
  )
}
